export default __webpack_public_path__ + "static/media/Automotive copy.52de59ec.jpg";